/* eslint-disable import/no-anonymous-default-export */
import React from "react";
import { Collapse } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleInfo,
  faClock,
  faStar,
} from "@fortawesome/free-solid-svg-icons";
import useInterviewVideos from "./useInterviewVideos";
import { convertDate, dateDiff, dateFormatter } from "../../../../_helpers/dateFormatter";
import VideoPlayer from "../../../../_uiComponents/VideoPlayerBasic";
import { Spinner, Tab, Tabs } from "react-bootstrap";

export default (props) => {
  const { Panel } = Collapse;
  const onChange = (key) => { };
  const {
    assignedInterviewKit,
    expandedAssessmentKitVideos,
    expandedAssessmentKitId,
    interviewVideosLoading,
    onAssessmentKitVideosClick,

    applicantHmsVideos,
    onInterviewVideosClick,
    getJoineesNames,
    allInterviewKitsQuestions,
    onAssessmentKitExpandClick,
  } = useInterviewVideos();

  return (
    <div className="interview-videos interview-videos-stats h-100">
      <div className="videos-list">
        <div className="topic-box">
          <div className="bg-white py-3  border border-radius-10">
            <h3 className="mb-3 ml-4">Interview Videos</h3>
            {interviewVideosLoading ? (
              <Spinner className="mx-4" variant="primary"/>
            ) : (
              <Tabs
                defaultActiveKey="AssessmentVideos"
                className="mb-4 border-bottom ml-4"
              >
                <Tab
                  eventKey="AssessmentVideos"
                  title="Assessment Videos"
                  className="mx-0"
                >
                  {assignedInterviewKit && assignedInterviewKit.length ? (
                    assignedInterviewKit &&
                    Array.isArray(assignedInterviewKit) &&
                    assignedInterviewKit.map(
                      (item) =>
                        expandedAssessmentKitId && (
                          <Collapse
                            onChange={() =>
                              onAssessmentKitExpandClick(item?.interview_kit)
                            }
                            defaultActiveKey={0}
                            className="mx-4 bg-white"
                          >
                            <Panel
                              header={
                                <div key={item?.interview_kit} className="">
                                  <h3 className="text-capitalize">
                                    {item?.interview_kit_detail &&
                                      item.interview_kit_detail?.title}
                                  </h3>
                                  <div className="d-flex justify-content-between align-items-center w-100">
                                    <div className="interview-videos w-100">
                                      <p className="mb-1 fs-smallest mt-3 font-weight-medium">
                                        <span className=" border pl-2 pr-0 py-1 rounded-lg mr-2">Topics{" "}
                                          <span className="bg-grey rounded-lg px-2 my-1">{item?.interview_kit_detail &&
                                            item.interview_kit_detail?.topics &&
                                            item.interview_kit_detail.topics
                                              ?.length}</span> </span>
                                        <span className=" border px-2 py-1 rounded-lg"> Questions{" "}
                                          <span className="bg-grey rounded-lg px-2 my-1">{allInterviewKitsQuestions(
                                            item?.interview_kit_detail?.topics
                                          )}
                                          </span>
                                        </span>
                                      </p>
                                      <div className="d-flex align-items-center justify-content-between  border-top pt-2 mt-3">
                                        <p className="text-grey-4 mb-0">
                                          Submitted{" "}
                                          {dateFormatter(
                                            item?.interview_kit_detail?.created
                                          )}
                                        </p>
                                        <button
                                          onClick={() =>
                                            onAssessmentKitVideosClick(
                                              item?.interview_kit
                                            )
                                          }
                                          className="btn text-primary"
                                        >
                                          View All
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              }
                              key={item?.interview_kit}
                            >
                              {Array.isArray(expandedAssessmentKitVideos) &&
                                expandedAssessmentKitVideos.length ? (
                                <div className="row">
                                  {expandedAssessmentKitVideos.map(
                                    (question) => (
                                      <div className="col-lg-12 mb-4">
                                        <div
                                          to="/view-assessment-video"
                                          className="interview-video-box "
                                        >
                                          <div className="video-box bg-white rounded-lg shadow-sm">
                                            <div className="top d-flex align-items-center p-2">
                                              <div className="user-img">
                                                <img
                                                  src="/assets/images/user.png"
                                                  alt="user img"
                                                />
                                              </div>
                                              <h4 className="mx-2 mb-0">
                                                {question?.question_detail &&
                                                  question.question_detail
                                                    ?.topic_name &&
                                                  question.question_detail.topic_name.substring(
                                                    0,
                                                    50
                                                  ) + "..."}
                                              </h4>
                                              <p className="h5 font-weight-normal text-grey-4  ml-auto mb-0">
                                                {convertDate(question?.created)}
                                              </p>
                                            </div>
                                            <div className="video-thumbnail">
                                              <VideoPlayer
                                                playbackId={
                                                  question?.video_asset_id
                                                }
                                                playBackDuration={0}
                                              />
                                            </div>
                                            <div className="video-info p-2">
                                              <h4 className="mb-2">
                                                {question?.question_detail &&
                                                  question.question_detail
                                                    ?.question &&
                                                  question.question_detail.question.substring(
                                                    0,
                                                    50
                                                  ) + "..."}
                                              </h4>
                                              <div className="d-flex align-items-center justify-content-between">
                                                {question?.skill &&
                                                  question.skill?.rating && (
                                                    <span>
                                                      <FontAwesomeIcon
                                                        icon={faStar}
                                                        className="mr-2 text-warning"
                                                      />
                                                      <span>
                                                        {question?.skill &&
                                                          question.skill
                                                            ?.rating}
                                                        .0
                                                      </span>
                                                    </span>
                                                  )}
                                                <span className="d-flex align-items-center text-primary">
                                                  {question?.question_detail &&
                                                    question.question_detail
                                                      ?.skill_names}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              ) : (
                                <div className="msg-bg text-white p-3 border-6 mb-3 mt-5 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                                  <p className="mb-0">
                                    <FontAwesomeIcon
                                      icon={faCircleInfo}
                                      className="text-white mr-2"
                                    />
                                    No questions submitted.
                                  </p>
                                </div>
                              )}
                            </Panel>
                          </Collapse>
                        )
                    )
                  ) : (
                    <div className="msg-bg text-white p-3 border-6 mb-3 mt-5 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                      <p className="mb-0">
                        <FontAwesomeIcon
                          icon={faCircleInfo}
                          className="text-white mr-2"
                        />
                        No Assessment Kit Videos found
                      </p>
                    </div>
                  )}
                </Tab>
                <Tab eventKey="InterviewVideos" title="Interview Videos">
                  <div className="topic-box">
                    <div className="bg-white">
                      <div className="interview-videos">
                        {Array.isArray(applicantHmsVideos) &&
                          applicantHmsVideos.length ? (
                          applicantHmsVideos.map((item, index) => (
                            <Collapse
                              onChange={onChange}
                              defaultActiveKey={0}
                              className="mb-3 mx-4 px-0 bg-white"
                            >
                              <Panel
                                header={
                                  <li className="d-flex flex-wrap justify-content-between align-items-start">
                                    <div className="px-0">
                                      <h3 className="mb-1">
                                        {" "}
                                        {index + 1}. {getJoineesNames(item)[0]}{" "}
                                        Interview with{" "}
                                        {getJoineesNames(item)[1]}
                                      </h3>
                                      <p className="mb-1 font-weight-medium text-grey-4">
                                        <div className="top d-flex align-items-center p-2">
                                          <h3 className="font-weight-medium mb-0">
                                            Scheduled on: {" "}
                                          </h3>
                                          <p className="h5 font-weight-normal text-grey-4 mb-0">
                                            {" "} {dateFormatter(item?.created)}
                                          </p>
                                        </div>
                                      </p>
                                    </div>
                                    <div>
                                      <button
                                        onClick={() =>
                                          onInterviewVideosClick(item?.room_id)
                                        }
                                        className="btn text-primary p-0"
                                      >
                                        View All
                                      </button>
                                    </div>
                                  </li>
                                }
                                key="2"
                              >
                                <div
                                  key={item?.id}
                                  className="rounded-lg mt-2"
                                >
                                  {item.room_videos.length ? (
                                    <div className="row">
                                      {item.room_videos.map((video) => (
                                        <div className="col-6 col-xl-4 mt-2">
                                          <div className="bg-white rounded-lg shadow-sm border">
                                            <div className="top d-flex align-items-center p-2">
                                              <h4 className="mx-2 mb-0">
                                                Interview on:{" "}
                                              </h4>
                                              <p className="h5 font-weight-normal text-grey-4  ml-auto mb-0">
                                                {convertDate(video?.created)}
                                              </p>
                                            </div>
                                            <div>
                                              <VideoPlayer
                                                playbackId={
                                                  video?.video_playback_id
                                                }
                                                playBackDuration={0}
                                              />
                                            </div>
                                            <div className="video-info p-2">
                                              <h4 className="mb-2">
                                                Duration{" "}
                                                <span className="text-muted">
                                                  <FontAwesomeIcon
                                                    icon={faClock}
                                                    className="mr-2 "
                                                  />
                                                  {dateDiff(
                                                    video?.session_started_at,
                                                    video?.session_stopped_at
                                                  )}
                                                </span>
                                              </h4>
                                            </div>
                                          </div>
                                        </div>
                                      ))}
                                    </div>
                                  ) : (
                                    <div className="msg-bg text-white p-3 border-6 my-3 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                                      <p className="mb-0 text-center">
                                        <FontAwesomeIcon
                                          icon={faCircleInfo}
                                          className="text-white mr-2"
                                        />
                                        No room videos saved yet.
                                      </p>
                                    </div>
                                  )}
                                </div>
                              </Panel>
                            </Collapse>
                          ))
                        ) : (
                          <div className="msg-bg text-white p-3 border-6 my-3 d-flex align-items-center justify-content-center mb-2 mw-50 mx-auto">
                            <p className="mb-0 text-center">
                              <FontAwesomeIcon
                                icon={faCircleInfo}
                                className="text-white mr-2"
                              />
                              No One On One Interview Video Found.
                            </p>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </Tab>
              </Tabs>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
